import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/poween/Navbar";
import { FloatingSpook } from "@/components/poween/FloatingSpook";
import { Hero } from "@/components/poween/Hero";
import { Marquee } from "@/components/poween/Marquee";
import { Tokenomics } from "@/components/poween/Tokenomics";
import { Roadmap } from "@/components/poween/Roadmap";
import { HowToBuy } from "@/components/poween/HowToBuy";
import { Footer } from "@/components/poween/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        const onAnchor = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const el = document.querySelector(a.getAttribute("href"));
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -70 });
            }
        };
        document.addEventListener("click", onAnchor);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            document.removeEventListener("click", onAnchor);
        };
    }, []);

    return (
        <div className="relative min-h-screen bg-[#0D0B14] text-slate-100">
            <div className="noise-overlay" aria-hidden="true" />
            <FloatingSpook />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Tokenomics />
                <Roadmap />
                <HowToBuy />
                <Marquee />
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: "#1C162E", border: "1px solid rgba(255,107,0,0.4)", color: "#F8FAFC" } }} />
        </div>
    );
}

export default App;
